import {Container , Button ,Card ,Row,Col , Image} from 'react-bootstrap'
import {TextField, FormControl , TextareaAutosize} from '@material-ui/core'
import SimpleSelect from '../HomeInquire '
import OfficeMoving1 from '../asset/image/Office-Shifting.png'
import { Route, Router } from 'react-router-dom';
import FooterLinks from '../FooterLink';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import './OfficeMoving.css'
import { ToastContainer,toast } from 'react-toastify';
import { useState } from 'react';
function OfficeMoving() {
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    movingTo: "",
    movingFrom: ""
})
let name, value
const postUserData = (event) => {
    name = event.target.name;
    value = event.target.value;
    setUserData({ ...userData, [name]: value });

}
const submitData = async (event) => {
    event.preventDefault();
    const { firstName, lastName, email, phoneNumber, movingTo, movingFrom } = userData

    if (firstName&&lastName&&email&&phoneNumber&&movingTo&&movingFrom){
        
    const res = fetch("https://infoform-c24b0-default-rtdb.firebaseio.com/homeShifting.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            firstName,
            lastName,
            email,
            phoneNumber,
            movingTo,
            movingFrom
        })

    })
   
    if(res){
        toast.success('Your Form Submitted!', {
            position: "top-center",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            });
        window.location.reload(false);
      
    }
    else{
        alert ("he")
    }  
}
     
        else{
            toast.error('Please Filled All', {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                });
        }
   

    

}
    function Qoute(){
        alert("SORRY :  This Service Is Unavailable At This Time")
        }
    function  NewsLetters() {
        alert("SORRY :  This Service Is Unavailable At This Time")
      }
      window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
       }); 
    return(
        <div  style={{backgroundColor:"	 #eee2e2"}}>
  <Container  >
                <Row className="OfficeMovingMain">
                    <Col md={6} className="mt-5">
                    <h1 className="OfficeMovingHeading">Make your Day Stressless With Rapid Movers Office Moving Services</h1>
                    <ul>
                        <li>Day and Night Shifting Service</li>
                        <li>Professional Team</li>
                        <li>24/7 Customer Support</li>
                      
                    </ul>
                    <h3 className="OfficeMovingHeading">  +92-3112755732</h3>
                    </Col>
                    <Col md={6} className="mt-5">
                    <Row>
              
              <Col md={5}>
                <TextField id="standard-basic" label="First Name" type="text" name="firstName" value={userData.firstName} onChange={postUserData} />
              </Col>
              <Col md={5}>
                <TextField id="standard-basic" label="Last Name" className="mb-3"  name="lastName"value={userData.lastName} onChange={postUserData}  />
              </Col>
    
              <Col md={5}>
                <TextField id="standard-basic" label="Email" type="mail" name="email" value={userData.email} onChange={postUserData}  />
              </Col>
              <Col md={5}>
                <TextField
                  id="standard-basic"
                  label="Phone Number"
                  type="text"
                  className="mb-3" name="phoneNumber" value={userData.phoneNumber} onChange={postUserData}
                />
              </Col>
    
              <Col md={5}>
                <TextField id="standard-basic" label="City"  name="movingTo" value={userData.movingTo} onChange={postUserData} />
              </Col>
              <Col md={5}>
                <TextField id="standard-basic" label="Country" className="mb-3"  name="movingFrom" value={userData.movingFrom} onChange={postUserData} />
              </Col>
              {/* <Col md={5} className="mb-3" >
                <SimpleSelect />
              </Col> */}
            </Row>                            <ToastContainer  />

                                <Row>
                                  <Col md={5}><Button
                    type="submit"
                    onClick={submitData}
                    className="OfficeMovingButton"
                  >
                    Submit Form
                  </Button></Col> <br/> <br/>
                                  <Col md={5}><Button type="reset"  onClick={()=>Qoute()} className="OfficeMovingButton">Reset Form</Button></Col>
                                </Row>
                    </Col>
                </Row>
                <h1 className="mt-4 OfficeMovingHeading" > Hire A Professional Company For Office Moving</h1>
                <p className="OfficeMovingText">Hiring an office moving service is one of the most important decisions of your life. A new destination may increase your office productivity and functionality and sometimes, it is necessary to move to another office to increase the space for your employees we are also providing employee moving services.
Rapid Packers and movers are trained in office moving services.</p>
<p className="OfficeMovingText">Rapid Packers and movers are trained in office moving services.
You can do your office work while rapid movers handle all the packing, moving, loading, unloading and all the stuff that you need.
Rapid packers and movers have wide range of services which includes one of our most important office moving services.</p>
<Row><Col md={6}>
  <p className="OfficeMovingText">
Our packing staff is fully trained to handle all the stuff with care we guarantee that your items will be moved in a hassle free manner. We hire a decent staff who will not misbehave with you 
or destroy your items. We take full responsibility for packing and transferring all the items like</p>
<ul>
    <li>Office Computers</li>
    <li>Printers</li>
    <li>Laptops</li>
    <li> Machines</li>
    <li>Cabinets</li>
    <li>Gadgets</li>
    <li> Air Conditioners and everything little thing.</li>
    </ul>

    </Col>
    <Col md={6}>
    <img as={Image}  src={OfficeMoving1} height="400px" width="100%"   className="OfficeMovingImage"/>
    </Col>
    </Row>
    <Row><Col md={12}>
        <h2 className="OfficeMovingHeading">Office Moving Cost Estimates</h2>
        <p className="OfficeMovingText">Most of the people can’t afford top-rate moving services and rapid movers are one of the top-rated moving services in Pakistan but the best thing about us that we still have cheap and affordable packages for everyone. And it is the fastest service you will ever experience. We truly understand the emotions of our 
            customers and we don’t give any burden to them, we just plan things and start to do work on it.</p>
        <p className="OfficeMovingText">So, if you are looking for affordable and best Office Furniture movers then rapid packers and movers will be the best option for you.
Our packing method is so unique. First, we collect all the items, then we measure each and everything, all the furniture, and all the files, etc. then we choose the boxes according to the size of an item and wrap the items and then put them into the box and the final step is to seal the boxes for protection.
We pack everything without any damage!</p>
        <p className="OfficeMovingText">After the move, it is difficult for any organization to have their staff restart their normal work and duties as 
            quickly as possible and for this reason, we introduce this service. Rapid Packers and movers can fix all the office furniture, Files, Gadgets, and other machinery. Let us come in after the move for making final adjustments to your furniture and remove the rubbish.</p>
            <p className="OfficeMovingText">So, if you are looking for office movers near me we are here to help you with everything during the relocation process.
Insha’Allah we will never disappoint you and will make you happy by showing our services.</p>
<p>Rapid Packers and movers are the best transporters for office items. You will definitely be stress-free and then recommend rapid movers to everyone who needs insha’Allah.
</p>
<p className="OfficeMovingText">Call us and get the best furniture packing and moving services in Pakistan.</p>
<h5 className="text-center">Alhamdulilah,  we are providing services with our whole heart! In Shaa Allah, we will never let you down.</h5>
        </Col></Row>
    
            </Container>

            <footer className="Footer1">
       <Container >
 <Row className="Footer">
   <Col md={3} ><Image src="https://ishfaqmovers.com/wp-content/uploads/2018/10/mo-white.png"  ></Image>
<h6 className="HomeFooterText">ISHFAQ MOVERS has been one of the leading packers &
   Movers in Karachi-Pakistan for more than 10 years. We deliver a broad range of targeted national and 
   international moving services for home, 
  house, villa, apartments, offices as well as relocation solutions for every purpose.</h6>
   </Col>
   <Col md={3} className="mt-3">
     <h3>QUICK LINKS</h3>

     <p><FooterLinks/></p>
 
     <Route path="/about"><FooterLinks/></Route>
     <Route path="/contact"><FooterLinks/></Route>
   </Col>
   <Col md={3}  className="mt-3">
   <h3>OUR SERVICES</h3>
   <p><FooterLinks/></p>
 
 <Route path="/about"><FooterLinks/></Route>
 <Route path="/contact"><FooterLinks/></Route>
   </Col>
   <Col md={3}  className="mt-">
   <h3>NEWSLETTER SIGNUP</h3>
  <h6>No spam, unsubscribe at any time.</h6>
   <TextField id="standard-basic" label="Email" type="mail"  /><br/>
   <Button onClick={()=>NewsLetters()} className="HomeButton mt-2 ">Subscribe</Button>
   <br/>
   <h5   className="mt-2 ">Contact On Social Media</h5>
   <a href="#"><FacebookIcon></FacebookIcon></a>
   <a href="#"><TwitterIcon></TwitterIcon></a>
   <a href="#"><InstagramIcon></InstagramIcon></a>
 
   </Col>
 </Row>
       </Container>
       <hr/>

       </footer>
        </div>
    )
    
}
export default OfficeMoving;